import { render } from "./ConfigurationUpgradeCancelled.vue?vue&type=template&id=0ff5d0c8&scoped=true"
import script from "./ConfigurationUpgradeCancelled.vue?vue&type=script&lang=js"
export * from "./ConfigurationUpgradeCancelled.vue?vue&type=script&lang=js"

import "./ConfigurationUpgradeCancelled.vue?vue&type=style&index=0&id=0ff5d0c8&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff5d0c8"]])

export default __exports__